import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Typography, CardContent } from "@material-ui/core";
import { hot } from "react-hot-loader";
import DayCell from "./DayCell";
import RowCell from "./RowCell";
import ControlCell from "./ControlCell";
import {
    getEventRows,
    deleteEventRow,
    getUsers,
    getTemplate,
    setTemplate,
    applyTemplate,
    getJobpacks
} from "./actions";
import {
    selectWeekCount,
    selectWeekDayStrings,
    selectDays,
    selectEventRows,
    selectJobpackKeys,
    getRequesting
} from "./selectors";
import ConfirmationModal from "./ConfirmationModal";
import EditRowCellModal from "./EditRowCellModal";
import EditDayCellModal from "./EditDayCellModal";

import {
    StyledCard,
  
    StyledHeader
} from "../../styles";

import { Modal, ModalBody, Spinner } from "reactstrap";


const MainContainer = styled.div`
    width: 100%;
    height: 100%;
    display: grid;
    grid-gap: 2px;
    overflow: hidden;
    grid-template-rows: 30px repeat(${props => props.rows}, 1fr);
    grid-template-columns: 170px repeat(${props => props.weekCount * 7}, 1fr);
    background-color: #3e50b5;
    border: 2px solid #3e50b5;
    border-radius: 4px;
`;


const StyledCardContent = styled(CardContent)`
    position: relative;
    height: calc(100% - 64px);
    padding-left: 20px;
    padding-right: 20px;
`;

const DateCell = styled.div`
    width: 100%;
    text-align: center;
    padding-top: 2px;
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: ${props => props.day + 2};
    grid-column-end: ${props => props.day + 3};
    background-color: #3f51b5;
    color: white;
    border-radius: 4px 4px 0 0;
`;

const fontSizes = [0.9, 0.7];
const DateText = styled.div`
    display: inline-block;
    font-size: ${props => fontSizes[props.weekCount - 1]}vw;
`;

class WeekPlanner extends React.Component {
    constructor(props) {
        super(props);
        props.getUsers();
        props.getEventRows();
        props.getTemplate();
        props.getJobpacks();
        this.state = {
            confirmDeleteModalOpen: false,
            editRowCellModalOpen: false,
            editDayCellModalOpen: false,
            setTemplateModalOpen: false,
            applyTemplateModalOpen: false,
            eventRow: false,
            eventRowIndex: false,
            dayCell: false,
            dayCellIndex: false
        };
    }

    render() {

        return (
            <React.Fragment>
                <Modal isOpen={this.props.requesting} style={{maxWidth: "00px"}}>
                        <ModalBody>
                        {this.props.requesting && ( 
                        <div style={{textAlign: "center", paddingTop: "3em"}}>
                            <div style={{background: "white", width: 'fit-content', display: 'inline-block', padding: "2em"}}>
                                <Spinner
                                    style={{
                                        height: 100,
                                        width: 100,
                                        background: "white"
                                    }}
                                    color="primary"
                                />
                                <Typography
                                    style={{
                                        textAlign: "center",
                                        marginTop: 15,
                                        color: "rgba(0, 0, 0, 0.87)",
                                        fontWeight: "bolder",
                                        fontSize: 20

                                    }}
                                    variant="body2"
                                >
                                Processing...
                                </Typography>                                
                            </div>
                        </div>)}
                        </ModalBody>
                    </Modal>
                <StyledCard>
                    <StyledHeader>
                    <Typography variant="headline">
                             Week Planner
                    </Typography>
                </StyledHeader>
                    <StyledCardContent>
                        <MainContainer
                            rows={this.props.rows.length}
                            weekCount={this.props.weekCount}
                        >
                            <ControlCell
                                setSetTemplateModalOpen={() => {
                                    this.setState({
                                        ...this.state,
                                        setTemplateModalOpen: true
                                    });
                                }}
                                setApplyTemplateModalOpen={() => {
                                    this.setState({
                                        ...this.state,
                                        applyTemplateModalOpen: true
                                    });
                                }}
                            />
                            {Array.isArray(this.props.weekDayStrings) &&
                                this.props.weekDayStrings.map((e, i) => {
                                    return (
                                        <DateCell key={i} day={i}>
                                            <DateText
                                                weekCount={this.props.weekCount}
                                            >
                                                {e}
                                            </DateText>
                                        </DateCell>
                                    );
                                })}

                            {Array.isArray(this.props.rows) &&
                                this.props.rows.map((e, i) => {
                                    return (
                                        <React.Fragment key={i}>
                                            <RowCell
                                                eventRowIndex={i}
                                                setConfirmDeleteModalOpen={() => {
                                                    this.setState({
                                                        ...this.state,
                                                        confirmDeleteModalOpen: true,
                                                        eventRowIndex: i
                                                    });
                                                }}
                                                setEditRowCellModalOpen={() => {
                                                    this.setState({
                                                        ...this.state,
                                                        editRowCellModalOpen: true,
                                                        eventRow: e,
                                                        eventRowIndex: i
                                                    });
                                                }}
                                                title={e.title}
                                            />
                                            {Array.isArray(e.events) &&
                                                e.events.map((event, j) => {
                                                    return (
                                                        <DayCell
                                                            event={event}
                                                            key={j}
                                                            row={i}
                                                            day={j}
                                                            setEditDayCellModalOpen={() => {
                                                                this.setState({
                                                                    ...this
                                                                        .state,
                                                                    editDayCellModalOpen: true,
                                                                    dayCell: event,
                                                                    eventRowIndex: i,
                                                                    dayCellIndex: j
                                                                });
                                                            }}
                                                        />
                                                    );
                                                })}
                                        </React.Fragment>
                                    );
                                })}
                        </MainContainer>
                    </StyledCardContent>
                </StyledCard>
                <ConfirmationModal
                    open={this.state.confirmDeleteModalOpen}
                    title={"Confirm Row Delete"}
                    handleCancel={() =>
                        this.setState({
                            ...this.state,
                            confirmDeleteModalOpen: false
                        })
                    }
                    handleConfirm={() => {
                        this.props.deleteEventRow(this.state.eventRowIndex);
                        this.setState({
                            ...this.state,
                            confirmDeleteModalOpen: false,
                            eventRow: false,
                            eventRowIndex: false
                        });
                    }}
                    confirmLabel={"Delete"}
                    cancelLabel={"Cancel"}
                />
                <ConfirmationModal
                    open={this.state.setTemplateModalOpen}
                    title={"Confirm Set Template"}
                    handleCancel={() => {
                        this.setState({
                            ...this.state,
                            setTemplateModalOpen: false
                        });
                    }}
                    handleConfirm={() => {
                        this.setState({
                            ...this.state,
                            setTemplateModalOpen: false
                        });
                        this.props.setTemplate();
                    }}
                    confirmLabel={"Set Template"}
                    cancelLabel={"Cancel"}
                />
                <ConfirmationModal
                    open={this.state.applyTemplateModalOpen}
                    title={"Confirm Apply Template"}
                    handleCancel={() => {
                        this.setState({
                            ...this.state,
                            applyTemplateModalOpen: false
                        });
                    }}
                    handleConfirm={() => {
                        this.setState({
                            ...this.state,
                            applyTemplateModalOpen: false
                        });
                        this.props.applyTemplate();
                    }}
                    confirmLabel={"Apply Template"}
                    cancelLabel={"Cancel"}
                />
                <EditRowCellModal
                    open={this.state.editRowCellModalOpen}
                    handleClose={() =>
                        this.setState({
                            ...this.state,
                            editRowCellModalOpen: false,
                            eventRow: false,
                            eventRowIndex: false
                        })
                    }
                    eventRow={this.state.eventRow}
                    eventRowIndex={this.state.eventRowIndex}
                />
                <EditDayCellModal
                    open={this.state.editDayCellModalOpen}
                    handleClose={() =>
                        this.setState({
                            ...this.state,
                            editDayCellModalOpen: false,
                            dayCell: false,
                            dayCellIndex: false
                        })
                    }
                    dayCell={this.state.dayCell}
                    dayCellIndex={this.state.dayCellIndex}
                    eventRowIndex={this.state.eventRowIndex}
                />
            </React.Fragment>
        );
    }
}

export default hot(module)(
    connect(
        store => {
            return {
                weekCount: selectWeekCount(store),
                weekDayStrings: selectWeekDayStrings(store),
                days: selectDays(store),
                rows: selectEventRows(store),
                jobpackKeys: selectJobpackKeys(store),
                requesting: getRequesting(store)
            };
        },
        {
            getEventRows,
            deleteEventRow,
            getUsers,
            getTemplate,
            setTemplate,
            applyTemplate,
            getJobpacks
        }
    )(WeekPlanner)
);
